import type { Meta, StoryObj } from "@storybook/react";
import { add } from "date-fns";

import type { JoinEventBannerProps } from "@/ui/components/home/JoinEventBanner";
import JoinEventBanner from "@/ui/components/home/JoinEventBanner";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<JoinEventBannerProps> = {
  title: "Components/Home/Join Event Banner",
  component: JoinEventBanner,
  argTypes: {
    endDate: { control: "text" },
    eventTitle: { control: "text" },
    startDate: { control: "text" },
    timeRange: { control: "text" },
  },
  args: {
    endDate: add(new Date(), { hours: 4 }).toISOString(),
    eventTitle: "Therapy Intake",
    startDate: new Date().toISOString(),
    timeRange: "1 - 2:30pm",
  },
  render: (props) => (
    <Box width="100%">
      <JoinEventBanner {...props} />
    </Box>
  ),
};

type Story = StoryObj<JoinEventBannerProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
